export const contractGist = [
    {
      title: "Utiliza un contrato ERC20 real desde GitHub Gist: copia, personaliza y aprende",
      value: `
  En este ejercicio trabajarás con un **contrato ERC20 publicado en GitHub Gist**, una fuente abierta y transparente usada por desarrolladores en todo el mundo.
  
  ---
  
  ### **¿Cómo usar un contrato de GitHub Gist?**
  
  1. **Accede al contrato en GitHub Gist**  
     Haz clic en este enlace para abrir el contrato inteligente ERC20:  
     👉 [Ver contrato ERC20 en GitHub Gist](https://gist.githubusercontent.com/Tootyr/8c2afcc5fa222de03444c2b05a1bf0fd/raw/f75f6559a36a4451b4a77cc302a908f79d127d1e/TootyrToken)  
     Allí verás el código fuente completo, listo para copiar y usar.
  
  2. **Copia todo el contenido del contrato**  
     Haz clic en el botón “Raw” para ver el código limpio, sin formato.  
     Selecciona desde la primera hasta la última línea (puedes usar Ctrl+A y luego Ctrl+C).
  
  3. **Pega el contrato en tu editor de texto**  
     Abre Sublime Text, VS Code, o [Remix IDE](https://remix.ethereum.org/)  
     Crea un archivo nuevo y pega el código copiado (Ctrl+V o Cmd+V).  
     **Guarda el archivo** con un nombre descriptivo, por ejemplo: \`MiTokenGist.sol\`.
  
  4. **Lee y comprende el contrato**  
     El contrato que has copiado implementa la lógica de un token ERC20 estándar, incluyendo las funciones para transferencia, aprobación, y consulta de balances.
  
  5. **Personaliza los valores clave**  
     Busca las líneas donde puedes editar:
     - El **nombre del token** (\`string public name\`)
     - El **símbolo** (\`string public symbol\`)
     - El **supply total** (\`uint public totalSupply\`)
     - El **número de decimales** (\`uint8 public decimals\`)
     Modifica estos valores según el proyecto que hayas elegido en la actividad anterior.
  
  6. **Compila y despliega el contrato**  
     Sube tu contrato personalizado a Remix IDE, verifica que no haya errores y compílalo.  
     Asegúrate de probarlo en una testnet (como Sepolia o Amoy) antes de desplegar en mainnet.
  
  ---
  
  ### **¿Por qué usar contratos de GitHub Gist o fuentes públicas?**
  - Te permite partir de una base segura y probada, auditada por la comunidad.
  - Aprendes a identificar las partes del contrato que puedes y debes personalizar.
  - Ganas práctica real en cómo los proyectos blockchain gestionan y publican sus contratos.
  
  ---
  
  **¡No olvides siempre dar crédito a los autores originales y revisar cada línea antes de lanzar tu contrato en una red real!**
  
  ![Ejemplo de contrato en GitHub Gist](https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/27-1.png)
  `
    }
  ];
  
  export default contractGist;
  